import { render, staticRenderFns } from "./YearBought.vue?vue&type=template&id=934cf3e4&"
import script from "./YearBought.vue?vue&type=script&lang=js&"
export * from "./YearBought.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports